import {
    Icon,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalHeaderWithTitleAndClose,
} from "best-common-react";
import React from "react";
import styled, { createGlobalStyle } from "styled-components";

const HeaderStyle = styled.div.attrs(() => ({
    className: "d-flex justify-content-between",
}))`
    width: 100%;
`;

const HeaderTextStyle = styled.div`
    font-size: 26px;
    font-weight: bold;
`;

const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #1e376d;
`;

const DialogWidthOverride = createGlobalStyle<{ $width: string }>`
    #modal.modal-dialog {
        max-width: ${props => props.$width};
    }
`;

const headerStyles = {
    backgroundColor: "#ffffff",
    borderBottomColor: "#92a5ba",
    border: "solid 1px var(--blue-grey)",
    color: "#1e376d",
};

type BigsModalProps = {
    isOpen: boolean;
    closeModal: Function;
    headerText: string;
    headerChild?: JSX.Element;
    headerActions?: React.ReactNode;
    size?: string;
    dialogMaxWidth?: string;
};

const BigsModal: React.FC<BigsModalProps> = ({
    isOpen,
    closeModal,
    headerText,
    headerChild,
    headerActions,
    size = "lg",
    dialogMaxWidth,
    children,
}) => {
    const handleClose = (event: React.SyntheticEvent) => {
        event.stopPropagation();
        closeModal();
    };

    return (
        <>
            {isOpen && dialogMaxWidth && <DialogWidthOverride $width={dialogMaxWidth} />}
            <Modal size={size} show={isOpen}>
                {headerActions ? (
                    <ModalHeader styles={headerStyles}>
                        <HeaderStyle>
                            <HeaderTextStyle>{headerText}</HeaderTextStyle>
                            <HeaderRight>
                                {headerActions}
                                <CloseButton type="button" aria-label="Close" onClick={handleClose}>
                                    <Icon iconName="fa-times" />
                                </CloseButton>
                            </HeaderRight>
                        </HeaderStyle>
                    </ModalHeader>
                ) : headerChild ? (
                    <ModalHeader styles={headerStyles}>
                        <HeaderStyle>
                            <HeaderTextStyle>{headerText}</HeaderTextStyle>
                            {headerChild}
                        </HeaderStyle>
                    </ModalHeader>
                ) : (
                    <ModalHeaderWithTitleAndClose
                        title={headerText || ""}
                        close={handleClose}
                        styles={headerStyles}
                    />
                )}

                {React.Children.map(children, (child: JSX.Element) => {
                    const type = !child || !child.type ? null : child.type.displayName;
                    switch (type) {
                        case "BodyContent":
                            return (
                                <ModalBody
                                    styles={{
                                        backgroundColor: "var(--snow)",
                                    }}
                                >
                                    {React.cloneElement(child, {})}
                                </ModalBody>
                            );
                        case "FooterContent":
                            return (
                                <ModalFooter
                                    styles={{
                                        backgroundColor: "#f2f3f4",
                                        borderTop: "none",
                                    }}
                                >
                                    <>{React.cloneElement(child, {})}</>
                                </ModalFooter>
                            );
                        default:
                            return null;
                    }
                })}
            </Modal>
        </>
    );
};

export default BigsModal;
